export default __webpack_public_path__ + "static/media/photo--lg--116.81411767.jpg";